var cookie = {
    lsCount: 0,
    getCookie: function(name){
        var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
        var arr = window.document.cookie.match(reg);
        if (!!arr) {
            return unescape(arr[2]);
        }else{
            return null;
        } 
    },
    setCookie: function (name, value) {
        // var strsec = toolBase.getSec(time || "");
        var exp = new Date();
        exp.setHours(23);
        exp.setMinutes(59);
        exp.setSeconds(59);
        // today.setTime(exp.getTime());
        window.document.cookie = name +"="+ escape (value) + ";expires=" + exp.toGMTString();
    },
    setNullPathCookie: function(name, value) {
        // var strsec = toolBase.getSec(time || "");
        var exp = new Date();
        exp.setHours(23);
        exp.setMinutes(59);
        exp.setSeconds(59);
        // today.setTime(exp.getTime());
        window.document.cookie = name +"="+ escape (value) + ";path=/" + ";expires=" + exp.toGMTString();
    },
    getlsCount: function(){
        return this.lsCount;
    },
    addlsCount: function(){
        this.lsCount++;
        this.lsCount = this.lsCount % 2;
        this.setCookie('focusbels', '' + this.lsCount);
    },
    init: function(){
        this.lsCount = parseInt(this.getCookie('focusbels'), 10) || 0;
        //console.log('baomingCount: ', this.baomingCount);
    }
};
cookie.init();
module.exports = cookie;


// WEBPACK FOOTER //
// ./~/@front-end/common-module-vm/shopping-cart/util/cookie.js